import React, { memo, useEffect } from 'react';
import { Badge, Button, Flex, Menu, Text } from '@mantine/core';

interface Props {
	projectsNames: string[];
	visibleBadgesCount?: number;
}

const ProjectsBadges = ({ projectsNames, visibleBadgesCount = 1 }: Props) => {
	const [visibleItems, setVisibleItems] = React.useState<string[]>([]);
	const [dropdownItems, setDropdownItems] = React.useState<string[]>([]);

	useEffect(() => {
		if (visibleBadgesCount === 0) {
			setVisibleItems([]);
			setDropdownItems(projectsNames);
			return;
		} else if (!visibleBadgesCount) {
			setVisibleItems(projectsNames);
			setDropdownItems([]);
			return;
		}

		setVisibleItems(projectsNames.slice(0, visibleBadgesCount));
		setDropdownItems(projectsNames.slice(visibleBadgesCount));
	}, [projectsNames, visibleBadgesCount]);

	return projectsNames.length ? (
		<Flex gap="0.25rem">
			{visibleItems.map((projectName) => (
				<Badge
					key={projectName}
					variant="filled"
					size="xs"
					color="gray.2"
					c="dark.4"
					sx={{ maxWidth: '15rem' }}
				>
					<Text size="B6Medium" truncate style={{ whiteSpace: 'nowrap' }}>
						{projectName}
					</Text>
				</Badge>
			))}

			{dropdownItems.length ? (
				<Menu shadow="md">
					<Menu.Target>
						<Button variant="ghost" size="xs" sx={{ borderRadius: '1rem' }}>
							<Text fz={10}>+{dropdownItems.length}</Text>
						</Button>
					</Menu.Target>

					<Menu.Dropdown
						sx={{
							borderRadius: '0.5rem',
							padding: '0.5rem',
							boxShadow: `0px 16px 32px 0px rgba(220, 223, 224, 1)`,
						}}
					>
						{dropdownItems.map((projectName) => (
							<Menu.Item key={projectName} sx={{ '&:hover': { cursor: 'initial' } }}>
								<Badge variant="filled" size="xs" color="gray.2" c="dark.4">
									<Text size="B6Medium" style={{ whiteSpace: 'nowrap' }}>
										{projectName}
									</Text>
								</Badge>
							</Menu.Item>
						))}
					</Menu.Dropdown>
				</Menu>
			) : null}
		</Flex>
	) : null;
};
const _ProjectsBadgesExport = memo(ProjectsBadges);

export { _ProjectsBadgesExport as ProjectsBadges };
